// extracted by mini-css-extract-plugin
export default {"mapContainer":"Map_mapContainer__8hzxP","invalidPostcode":"Map_invalidPostcode__le81k"};